<template>
  <div class="w-table-wrap" style="max-height: 800px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'MAKLUMAT TERNAKAN'" >
         <template #title>
            SENARAI TERNAKAN
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedList = !isMinimizedList">
                  <template v-if="isMinimizedList">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
      <div v-show="!isMinimizedList">
      <div class="w-table-wrap" style="max-height: 1400px;" >
      <div class="w-flex wrap smd-column" >
         <div class="grow " style="line-height: 35px">
            <table >
              <tbody>
               <tr class="row_data">
                  <td><b>Tarikh Pemeriksaan</b></td>
                  <td><b>:</b></td>
                  <td>
                   <template v-if="(datas.lkp_status_id==34 && datas.pemeriksaan!=1) || datas.lkp_status_id==32 || datas.lkp_status_id==27 ">
                        <template v-if="datas.art_user_id == $page.props.auth.user.id">
                              <w-input type="date" v-model="datas.tarikh_pemeriksaan" :validators="[validators.required]" outline ></w-input>
                       </template>
                   </template>
                   <template v-else>
                           {{$zutil.dateformat(datas.tarikh_pemeriksaan_format)}}
                   </template>
                 </td>
               </tr>
               </tbody>
            </table>
         </div>
      </div>
      <br>
      <div class="table-profil-scrol">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-center" width="1%">BIL</th>
              <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
              <th class="w-table__header  text-center">STATUS KESIHATAN<i aria-hidden="true" style=" color: red;">*</i></th>
              <th class="w-table__header  text-center">SKOR BADAN<i aria-hidden="true" style=" color: red;">*</i></th>
              <th class="w-table__header  text-center">STATUS KEBUNTINGAN<i aria-hidden="true" style=" color: red;">*</i></th>
              <th class="w-table__header  text-center">USIA KEBUNTINGAN (BULAN)</th>
              <th class="w-table__header  text-center">TARIKH JANGKAAN KELAHIRAN</th>
              <th class="w-table__header  text-center">CATATAN</th>
              <th class="w-table__header  text-center">STATUS PEMERIKSAAN</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="datas.ternakan_list.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in datas.ternakan_list">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.ternakan_nama}}</td>
                  <template v-if="(datas.pemeriksaan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                     <td class="w-table__cell text-left" style="margin:5px;"><div style="width:120px"></div>
                          {{dt.lkp_status_kesihatan}}
                       </td>
                  </template>
                  <template v-else>
                     <td class="w-table__cell text-left" style="margin:5px;"><div style="width:120px"></div>
                     <w-select style="margin:5px;" class="mt4" placeholder="Pilih Satu.." outline :items="lkp_status_kesihatan" v-model="dt.lkp_status_kesihatan_id" :validators="[validators.required]" :disabled="!datas.tarikh_pemeriksaan"/>
                     </td>
                  </template>
                  <template v-if="(datas.pemeriksaan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                     <td class="w-table__cell text-left">
                     {{dt.skor_badan}}
                     </td>
                  </template>
                  <template v-else>
                     <td class="w-table__cell text-left">
                        <w-select style="margin:5px;" class="mt4" placeholder="Pilih Satu.." outline :items="skorbadanlist" v-model="dt.skor_badan" :validators="[validators.required]" :disabled="!datas.tarikh_pemeriksaan"/>
                     </td>
                  </template>
                <td class="w-table__cell text-left" >
                  <template v-if="(datas.pemeriksaan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                    <template v-if="dt.bunting==1">BUNTING</template><template v-else>TIDAK BUNTING</template>
                  </template>
                  <template v-else>
                    <w-select style="margin:5px;" placeholder="Pilih Satu.." class="mt4" outline :items="bunting" @input="getTarikhJangkaan(dt, dt.usia_bunting)" v-model="dt.bunting" :validators="[validators.required]" :disabled="!datas.tarikh_pemeriksaan"/>
                  </template>
                </td>
                <template v-if="(datas.pemeriksaan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                  <td class="w-table__cell text-right" >
                    {{dt.usia_bunting}}
                  </td>
                </template>
                <template v-else>
                  <td class="w-table__cell text-left" >
                    <w-input style="margin:5px;" min="0" type="number" placeholder="Sila masukan.." class="mt4" outline v-model="dt.usia_bunting" @change="getTarikhJangkaan(dt, dt.usia_bunting)" :disabled="dt.bunting==2 || !datas.tarikh_pemeriksaan"/>
                  </td>
                </template>
                <td class="w-table__cell text-center" style="margin:5px;">{{$zutil.dateformatBulanTahun(dt.jankaan_kelahiran)}}</td>
                <template v-if="(datas.pemeriksaan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                  <td class="w-table__cell text-left" >
                    {{dt.catatan}}
                  </td>
                </template>
                <template v-else>
                  <td class="w-table__cell text-left" ><div style="width:110px"></div>
                     <template v-if="dt.skor_badan ==1">
                        <w-textarea style="margin:5px;" placeholder="Sila masukan.." class="mt4" outline v-model="dt.catatan" :validators="[validators.required]"/>
                     </template>
                     <template v-else>
                        <w-textarea style="margin:5px;" placeholder="Sila masukan.." class="mt4" outline v-model="dt.catatan" :disabled="!datas.tarikh_pemeriksaan"/>
                     </template>
                  </td>
                </template>
                <template v-if="(datas.pemeriksaan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                  <td class="w-table__cell text-left" >
                     <template v-if="dt.status_pemeriksaan==1">LULUS</template><template v-else>TIDAK LULUS</template>
                  </td>
                </template>
                <template v-else>
                  <td class="w-table__cell text-left" ><div style="width:110px"></div>
                    <w-select style="margin:5px;" placeholder="Pilih Satu.." class="mt4" outline :items="status_pemeriksaan" v-model="dt.status_pemeriksaan" :validators="[validators.required]" :disabled="!datas.tarikh_pemeriksaan"/>
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
        </div>
        <w-flex class="mt3" wrap align-center justify-end v-if="(datas.pemeriksaan!=1&&datas.lkp_status_id==34)||datas.lkp_status_id==27||datas.lkp_status_id==32">
          <w-button class="my1" type="submit" :disabled="loading || !datas.tarikh_pemeriksaan" :loading="loading">
            <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
          </w-button>
          &nbsp;
          <!-- <w-button class="my1" bg-color="success" type="submit" :disabled="loading" :loading="loading">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button> -->
        </w-flex>
      </div>
      </div>
      </w-card>
    </w-form>
  </div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.ai-aiman',
      form : {},
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,

      bunting:[
        {value: 1, label: "BUNTING"},
        {value: 2, label: "TIDAK BUNTING"}
      ],
      status_pemeriksaan:[
         {value: 1, label: "LULUS"},
         {value: 2, label: "TIDAK LULUS"}
      ],
      validators: {
          required: (value) => value !== null && value !== undefined && value !== '' || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      lkp_status_kesihatan: [],
      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],
      isMinimizedList: false
      
    }
  },
  methods:{
    calculateDueMonth(currentDate, pregnancyDays, monthsCompleted) {
        // kiraan by bulan
        const averageDaysPerMonth = pregnancyDays / 9;
        const daysElapsed = monthsCompleted * averageDaysPerMonth;
        const remainingDays = pregnancyDays - daysElapsed;
        const dueDate = new Date(currentDate);
        dueDate.setDate(dueDate.getDate() + remainingDays);
        // const dueMonth = dueDate.toLocaleString('default', { month: 'long' });
        // const dueYear = dueDate.getFullYear();

        // return `${dueMonth} ${dueYear}`;
        const yyyy = dueDate.getFullYear();
        const mm = String(dueDate.getMonth() + 1).padStart(2, '0');
        const dd = String(dueDate.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    },
    getTarikhJangkaan(dt, usia_bunting){

      if(dt.bunting==1){
        const bunting_ternakan = this.datas.bunting_ternakan;
        const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
        dt.status_pemeriksaan = 2;
        // kiraan by hari
        // const totalhari = bunting_ternakan - usia_bunting;
        // tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + totalhari);
        // const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;

        dt.jankaan_kelahiran = this.calculateDueMonth(tarikh_pemeriksaan, bunting_ternakan, usia_bunting); 
      }else{
        // const usia_bunting_0 = 0;
        // const bunting_ternakan = this.datas.bunting_ternakan;
        // const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);

        // const totalhari = bunting_ternakan - usia_bunting_0;

        // tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + totalhari);
        // const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;
        // dt.jankaan_kelahiran = formattedDate;
         dt.jankaan_kelahiran=null;
        dt.usia_bunting =0;
        dt.status_pemeriksaan = 1;
      }
   },
    lkpBerahi()
    {
      this.$zcomm.get(this.api_service + 'lookup/berahi', {}).then(res => {
        this.lkp_berahi = res
      })
    },
    lkpStatusKesihatan()
    {
      this.$zcomm.get(this.api_service + 'lookup/status_kesihatan', {}).then(res => {
        this.lkp_status_kesihatan = res
      })
    },
    validateForm() {
      this.loading=true;
      let isValid = true;

      // if(this.datas.lkp_status_id!=32){
         this.datas.ternakan_list.forEach((row) => {
            if (row.lkp_status_id !=28) {
               if (!row.lkp_status_kesihatan_id || !row.skor_badan || !row.bunting || !row.status_pemeriksaan) {
                  if (row.skor_badan==1 && !row.catatan) {
                     isValid = false;
                     this.loading=false;
                  }else{
                     isValid = false;
                     this.loading=false;
                  }
               }
               if (row.skor_badan==1 && !row.catatan || row.bunting==1 && row.usia_bunting==0 ) {
                  isValid = false;
                  this.loading=false;
               }

            }
         });
      // }

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.datas.ternakan_list, pemeriksaan:1, tarikh_pemeriksaan:this.datas.tarikh_pemeriksaan})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.semakan.ai-aiman', this.datas.id));
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.datas.ternakan_list, pemeriksaan:1, tarikh_pemeriksaan:this.datas.tarikh_pemeriksaan})
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.semakan.ai-aiman', this.datas.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
  },
      
  mounted() {
    this.lkpBerahi();
    this.lkpStatusKesihatan();
    // this.datas = this.data;
  }
}
      

</script>  
